webpackJsonp([132522351814799],{

/***/ 472:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Anthony Urbano","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/1SqbwGvjqw2WOKUcgAgyw2/9301d713d09230f8e0fc4c2b74255fc9/Eteny.jpg"}},"content":{"content":"![blogMSA005U](//images.contentful.com/1o5ly3na7qu2/2aCyHswLyMg44o4SmYIK62/87cff12baab130fc8b0417135df32d9d/blogMSA005U.JPG)\n\n__Anthony Urbano__\n- MSA Co-Founder\n- NISMED\n- Alumni, UP Astronomical Society\n- Amateur astronomer, astronomy educator, astrophotographer, astro-blogger\n\n"}}},"pathContext":{"id":"c6VUCMjzpG8iYQWKYiA4Qo"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-anthony-urbano-5aab8ec4249f540914bf.js